import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select } from "antd";

import tablesInfoActions from "../../../redux/tablesInfo/actions";
import { useProjectState } from "../../../context/stateContext";
import DatePickerComponent from "../../Common/DatePicker/DatePicker";
import "./index.css";

const { getDailyTableStatistics } = tablesInfoActions;
const { Option } = Select;

const TableInfoActions = () => {
  const dispatch = useDispatch();
  const {
    selectedOrganization,
    allSectedRestaurants,
    setAllSelectedRestaurants,
    startDate,
    endDate,
  } = useProjectState();

  const { restaurants, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );

  const defaultTouchSaleRestaurantId =
    defaultOrganization[0]?.defaultTouchSaleRestaurantId;

  useEffect(() => {
    if (defaultOrganization.length > 0) {
      setAllSelectedRestaurants([
        defaultOrganization[0]?.defaultTouchSaleRestaurantId,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTouchSaleRestaurantId, selectedOrganization]);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(
        getDailyTableStatistics(startDate, endDate, allSectedRestaurants)
      );
    }, 1000);
    return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, defaultTouchSaleRestaurantId, startDate, endDate]);

  const handleOnChangeRestaurant = (restaurant) => {
    setAllSelectedRestaurants([restaurant]);
    dispatch(getDailyTableStatistics(startDate, endDate, allSectedRestaurants));
  };

  return (
    <>
      <div className="table-info-action-buttons-container">
        {defaultOrganization[0]?.multipleRestaurants && (
          <Select
            showSearch={false}
            virtual={false}
            key="driversInfoRestaurantSelect"
            placeholder="Изберете ресторант"
            onChange={handleOnChangeRestaurant}
            value={allSectedRestaurants}
            className="table-info-action-buttons"
          >
            {restaurants?.map((restaurant, index) => (
              <Option
                key={restaurant.id}
                value={restaurant.id}
                className="table-info-select-option"
              >
                {restaurant.name}
              </Option>
            ))}
          </Select>
        )}
        <DatePickerComponent />
      </div>
    </>
  );
};

export default TableInfoActions;
